// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Apo5L","header":"styles_header__kHXcu"};